
import ImageFuture from "next/image";

const PureCarsImage = ({ vin }: { vin: string}) => {
    return (
        <ImageFuture
            src={`//mvh.purecars.com/images/srp.aspx?id=100016328&vin=${vin}`}
            className="amx-pure-cars-img-2"
            loading="lazy"
            width={173}
            height={22}
            alt="PureCars Value Report"
        />
    );
};

export default PureCarsImage;
